/**
 * Shared client-side state that remembers the `page_section` of the route the
 * user was on right before navigating into the cart page.
 *
 * Set by the `cart-origin-section` router plugin before the `/cart` route
 * resolves; read by `useCartTracking().trackViewCart` so `view_cart` reports
 * where the user decided to proceed to cart from.
 */
export function useCartOriginSection() {
  const originSection = useState<string | undefined>('cart-origin-section', () => undefined)

  function setOriginSection(section: string | undefined) {
    originSection.value = section
  }

  function getOriginSection(): string | undefined {
    return originSection.value
  }

  return { setOriginSection, getOriginSection }
}
